module.exports = __webpack_public_path__ + "h5/img/service1.922689a6.png";